<template>
    <table class="table table-hover dynamic-table">
        <thead class="bg-gray-light">
        <tr>
            <th>
                <sort-by title="ID" :sort="getSort('id')" name="id"/>
            </th>
            <th>
                {{ typeReport.name }}
            </th>
            <th>
                Reason
            </th>
            <th>
                Description
            </th>
            <th>
                <sort-by title="Failed" :sort="getSort('failed')" name="failed"/>
            </th>
            <th>
                <sort-by title="Count" :sort="getSort('count')" name="count"/>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="items.length > 5" class="without-color">
            <th :colspan="colspanTotal">
                Total
            </th>
            <th>
                {{ report.totals.failed }}
            </th>
            <th>
                {{ report.totals.count }}
            </th>
        </tr>
        <template v-for="(value) in items" v-if="value.messages_count !== '0'">
        <tr class="main-reason-tr">
            <td>
                <span v-if="value.entity">
                    {{ value.entity.id }}
                </span>
                <span v-else>-</span>
            </td>
            <td>
                <span v-if="value.entity && value.entity.route">
                    <a :href=value.entity.route>
                        {{ value.entity.name }}
                    </a>
                </span>
                <span v-else-if="value.entity">
                    {{ value.entity.name }}
                </span>
                <span v-else>Unknown</span>
            </td>
            <td colspan="2"></td>
            <td>
                <span class="label bg-gray">{{ value.failed }}</span>
            </td>
            <td>
                <span class="label bg-gray">{{ value.count }}</span>
            </td>
        </tr>
        <tr v-for="(reason) in value.reasons">
            <td colspan="2"></td>
            <td>
                <span>{{ reason.code }} ({{ reason.api_type | capitalize }})</span>
            </td>
            <td>
                <span>{{ reason.message }}</span>
            </td>
            <td>
                <span class="label bg-gray">{{ reason.failed }}</span>
            </td>
            <td>
                <span class="label bg-gray">{{ reason.count }}</span>
            </td>
        </tr>
        </template>
        </tbody>
        <tfoot>
        <tr>
            <th :colspan="colspanTotal">
                Total
            </th>
            <th>
                {{ report.totals.failed }}
            </th>
            <th>
              {{ report.totals.count }}
            </th>
        </tr>
        </tfoot>
    </table>
</template>

<script>
import BadgeTotal from "../subcomponents/BadgeTotal";
import SortBy from "../subcomponents/SortBy";
import EventBus from '../../event-bus';
import ValueYesNo from "../subcomponents/ValueYesNo";

export default {
    props: [
        'report',
        'typeReport',
        'additionalRelationTitles'
    ],
    data: function () {
        return {
            colspanTotal: this.additionalRelationTitles.length + 4,
            sortDirections: [],
            items: this.report.items,
        }
    },
    mounted() {
        EventBus.$on('setSort', (data) => {
            this.setSort(data)
        })
    },
    methods: {
        setSort(key) {
            let direction = null;
            if (!this.sortDirections[key]) {
                direction = 'desc';
            } else if (this.sortDirections[key] === 'desc') {
                direction = 'asc';
            }
            this.sortDirections = [];
            this.sortDirections[key] = direction;
            this.items = direction ? _.orderBy(this.report.items, [key], [direction]) : this.report.items;
        },
        getSort(key) {
            return this.sortDirections[key] ? 'sort-' + this.sortDirections[key] : 'unsorted';
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) return '';
            value = value.toString();

            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    components: {
        ValueYesNo,
        SortBy,
        BadgeTotal
    },
}
</script>
